export default __webpack_public_path__ + "static/media/jeans8.dc8a044a.jpeg";